/**
 * Removes raw `<cite source="...">` and `<cite_source="...">` tags from markdown text.
 */
export const stripCiteTags = (text: string): string => {
  const citeTagRegex = /<cite[\s_]+source="[^"]*"\s*\/?>/g;
  return text.replace(citeTagRegex, "");
};
